import styled from 'styled-components';

import { TYPOGRAPHY } from '@ui-component-library/components/_deprecated/Typography';

import COLORS from '@ui-component-library/styles/colors';
import { DROPDOWN_RESET } from '@ui-component-library/styles/components.reset';
import { SPACING } from '@ui-component-library/styles/spacing';

export const S = {
  Wrapper: styled.div<{
    variant: 'default' | 'fluid';
    disabled: boolean;
  }>`
    ${DROPDOWN_RESET}

    width: 100%;
    opacity: ${(props) => (props.disabled ? 0.6 : 1)};
    position: relative;
  `,

  TopSection: styled.div`
    padding-bottom: ${SPACING.size8};
    display: flex;
    flex-direction: column;
    gap: ${SPACING.size4};
  `,

  Label: styled.label`
    ${TYPOGRAPHY.labelMediumRegularDense}
    color: ${COLORS['charcoal-500']};
    display: flex;
    align-items: center;
    gap: ${SPACING.size4};
  `,

  FluidLabel: styled.label`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    color: ${COLORS['charcoal-500']};
    position: absolute;
    top: 2px;
    left: 16px;
  `,

  FluidLabelIcon: styled.div`
    padding-left: 4px;
    display: flex;
    align-items: center;
  `,

  Description: styled.p`
    ${TYPOGRAPHY.overlineMediumRegular}
    color: ${COLORS['cloud-900']};
  `,

  SelectContainer: styled.div<{
    $state: 'success' | 'error' | 'idle' | 'disabled';
  }>`
    background-color: ${COLORS['white-50']};
    position: relative;
    border-radius: 12px;
    border: 1px solid
      ${(props) => {
        switch (props.$state) {
          case 'success':
            return COLORS['success-900'];
          case 'error':
            return COLORS['danger-500'];
          case 'disabled':
          case 'idle':
            return COLORS['charcoal-alpha-50'];
        }
      }};

    display: flex;
    align-items: center;
    margin-bottom: ${SPACING.size8};

    //  FIXME: Make focus-visible from accessibility perspective look better. Instead of default
    /* &:focus-within {
      outline: 2px solid #0066ff;
      outline-offset: 2px;
    } */

    &:focus-visible {
      outline: 2px solid ${COLORS['info-500']};
      outline-offset: 4px;
    }
  `,

  Select: styled.select<{
    $isFluid?: boolean;
  }>`
    ${TYPOGRAPHY.labelMediumMedium}
    padding-left: ${SPACING.size16};
    appearance: none;

    border: 0;
    background: transparent;
    text-overflow: ellipsis;
    color: ${COLORS['charcoal-500']};
    min-width: 100%;

    height: ${(props) => (props.$isFluid ? '42px' : '56px')};
    margin-top: ${(props) => (props.$isFluid ? '12px' : 'unset')};
    z-index: 1;

    &::placeholder {
      color: ${COLORS['charcoal-300']};
    }

    &:focus-visible {
      // Looks bad when item is selected. Disabled it for now.
      /* 
      border-radius: 12px;
      outline: 2px solid ${COLORS['info-500']};
      outline-offset: 4px;
      */
      outline: none;
      border: 0;
    }
  `,

  IconWrapper: styled.div`
    padding: ${SPACING.size12} ${SPACING.size16};
    display: flex;
    align-items: center;
    position: absolute;
    right: 0;
  `,

  Suffix: styled.p`
    ${TYPOGRAPHY.labelMediumRegular}
    color: ${COLORS['charcoal-300']};
    padding-right: ${SPACING.size16};
    text-align: right;
  `,

  Button: styled.button`
    border: none;
    background: none;
    padding: ${SPACING.size12} ${SPACING.size16};
    cursor: pointer;
    display: flex;
    align-items: center;
  `,

  BottomSection: styled.div`
    display: flex;
    align-items: center;
    gap: 4px;
    padding-left: ${SPACING.size12};
    height: 12px;
  `,

  HelperText: styled.p<{ $validationState: 'success' | 'error' | 'idle' }>`
    ${TYPOGRAPHY.labelXtraSmallRegular}
    color: ${(props) => {
      switch (props.$validationState) {
        case 'success':
          return COLORS['success-900'];
        case 'error':
          return COLORS['danger-500'];
        default:
          return COLORS['pebble-500'];
      }
    }};
  `,

  Error: styled.p``
};
